import { ComponentPropsWithoutRef, ReactNode } from 'react';

export type TextElement =
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'p'
    | 'span'
    | 'div'
    | 'label'
    | 'strong'
    | 'em'
    | 'small'
    | 'th'
    | 'td';

export type TextVariant =
    | 'heading'
    | 'normal';

export type TextTone =
    | 'primary'
    | 'secondary'
    | 'success'
    | 'destructive'
    | 'warning'
    | 'disabled'
    | 'inherit';

export type TextAlign = 'left' | 'center' | 'right';
export type TextWeight = 'regular' | 'medium' | 'semibold' | 'bold';
export type TextSize = 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'inherit';
export type LineHeight = 'normal' | number;

export const Variants: Partial<Record<TextElement, TextVariant>> = {
    h1: 'heading',
    h2: 'heading',
    h3: 'heading',
    h4: 'heading',
    h5: 'heading',
    h6: 'heading',
} as const;

type TextOwnProps<T extends TextElement> = {
    as?: T;
    variant?: TextVariant;
    tone?: TextTone;
    align?: TextAlign;
    weight?: TextWeight;
    size?: TextSize;
    truncate?: boolean;
    className?: string;
    children?: ReactNode;
    lineHeight?: LineHeight;
};

export type TextProps<T extends TextElement = 'div'> =
    TextOwnProps<T> &
    Omit<ComponentPropsWithoutRef<T>, keyof TextOwnProps<T>>;
